import { render, staticRenderFns } from "./UserGroupSummary.vue?vue&type=template&id=c01a4df6&scoped=true&"
import script from "./UserGroupSummary.vue?vue&type=script&lang=ts&"
export * from "./UserGroupSummary.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupSummary.vue?vue&type=style&index=0&id=c01a4df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01a4df6",
  null
  
)

export default component.exports